<template>
  <el-dialog
    class="rc-dialog"
    title="学员数字画像详情"
    :visible.sync="dialogInfo.show"
    @close="closeDialog"
    :close-on-click-modal="false"
    destroy-on-close
    width="35%"
  >
    <ScorePlate :labels="labels" :scores="scores" />
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" title="取消"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { classEnrollExamInfoNew } from "@/api/user";
import ScorePlate from "@/pages/user/learningInfo/scorePlate.vue";
export default {
  components: { butn, ScorePlate },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      labels: [],
      scores: [],
    };
  },
  created() {
    classEnrollExamInfoNew(this.dialogInfo.uuid).then(({ code, data }) => {
      if (code !== 0) return;
      let kv = this.generateData(data);
      this.labels = kv[0];
      this.scores = kv[1];
    });
  },
  methods: {
    closeDialog() {
      this.$emit("close", false);
    },
    generateData(data) {
      let keys = [];
      let values = [];
      for (let i = 0; i < data.length; i++) {
        let { childExamItems = [], examItem = "", score = 0 } = data[i];
        if (childExamItems.length > 0) {
          let innerKeys = [];
          let innerValues = [];
          childExamItems.forEach((x) => {
            innerKeys.push(x.examItem);
            innerValues.push(x.score);
          });
          keys.push([examItem, ...innerKeys]);
          values.push(...innerValues);
        } else {
          keys.push([examItem]);
          values.push(score);
        }
      }
      return [keys, values];
    },
  },
};
</script>

<style lang="scss" scoped>
.curdForm {
  text-align: center;
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}
.m-b-12 {
  margin-bottom: 12px;
}
</style>
